/**
 * /my-coaching/business/courses/$courseSlug — a published course. This layout gives the course and its weeks their
 * breadcrumb; a draft or unknown slug is a 404, so a course stays invisible
 * until an admin publishes it.
 */

import { Outlet, createFileRoute, notFound } from "@tanstack/react-router";

import { myCourseQueryOptions } from "~/lib/queries/learningQuery";
import { courseSlugSchema } from "~/lib/shared/learning/admin-inputs";

export const Route = createFileRoute(
  "/_user/my-coaching/business/courses/$courseSlug",
)({
  staticData: { title: "Course" },
  loader: async ({ context, params }) => {
    if (!courseSlugSchema.safeParse(params.courseSlug).success) {
      throw notFound();
    }
    const course = await context.queryClient.ensureQueryData(
      myCourseQueryOptions(params.courseSlug),
    );
    if (!course) throw notFound();
    return { title: course.title };
  },
  component: () => <Outlet />,
});
